import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useMembership } from '../../context/contexts';
import { detailing1, detailing2, detailing3 } from '../../imports';
import { FaArrowLeft } from 'react-icons/fa';
import './Memberships.css';

const membershipsData = [
    {
        id: 1,
        name: 'Sedan',
        photo: detailing1,
        price: 99
    },
    {
        id: 2,
        name: 'Truck/Medium SUV',
        photo: detailing2,
        price: 119
    },
    {
        id: 3,
        name: 'Large SUV/Van',
        photo: detailing3,
        price: 149
    }
];

const membershipSummary = [
    {
        id: 1,
        note: 'One-time registration fee of $360. Your selected membership fee will start from the second month.'
    },
    {
        id: 2,
        note: 'Membership quaterly service includes: Monthly maintenance, quarterly protective detailing services, semi-annual deep detailing services'
    }
];

const UserMemberships = () => {
    const { userMemberships } = useMembership();

    if (!userMemberships || userMemberships.length === 0) {
        return null;
    }

    return (
        <div className="user-memberships">
            <h3>Your Active Memberships</h3>
            <div className="memberships-list">
                {userMemberships.map(membership => (
                    <div key={membership.id} className="membership-item">
                        <div className="membership-info">
                            <h4>{membership.membership_type}</h4>
                            <p className="price">${membership.price}/month</p>
                            <p className="start-date">Started: {new Date(membership.start_date).toLocaleDateString()}</p>
                        </div>
                        <div className="membership-status">
                            <span className="status-badge active">Active</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const RegistrationForm = ({ onSubmit }) => {
    const { goBack } = useMembership();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="step-container">
            <button className="back-button" onClick={goBack}>
                <FaArrowLeft /> Back
            </button>
            <form onSubmit={handleSubmit} className="registration-form">
                <h3>Quick Registration</h3>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={(e) => setFormData(prev => ({ ...prev, firstName: e.target.value }))}
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={(e) => setFormData(prev => ({ ...prev, lastName: e.target.value }))}
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                        required
                    />
                </div>
                <button type="submit" className="submit-btn">Continue to Payment</button>
            </form>
        </div>
    );
};

const PaymentSection = () => {
    const { selectedMembership, goBack } = useMembership();

    return (
        <div className="step-container">
            <button className="back-button" onClick={goBack}>
                <FaArrowLeft /> Back
            </button>
            <div className="payment-section">
                <h3>Payment Summary</h3>
                <div className="payment-details">
                    <div className="payment-row total">
                        <span>One-time Registration Fee:</span>
                        <span>$360</span>
                    </div>
                </div>
                <div className="future-payment-info">
                    <h4>Future Payments</h4>
                    <p>Starting next month, your monthly membership fee will be:</p>
                    <p className="future-price">${selectedMembership?.price}/month</p>
                </div>
                {/* Square Payment Integration will go here */}
                <button className="payment-btn">Process Payment</button>
            </div>
        </div>
    );
};

const Memberships = () => {
    const { currentUser } = useAuth();
    const { 
        selectedMembership,
        paymentStep,
        selectMembership,
        registerUser
    } = useMembership();

    const renderStep = () => {
        switch (paymentStep) {
            case 'register':
                return <RegistrationForm onSubmit={registerUser} />;
            case 'payment':
                return <PaymentSection />;
            default:
                return (
                    <>
                        <UserMemberships />
                        <div className="memberships-grid">
                            {membershipsData.map(membership => (
                                <div 
                                    key={membership.id} 
                                    className={`membership-card ${selectedMembership?.id === membership.id ? 'selected' : ''}`}
                                    onClick={() => selectMembership(membership)}
                                >
                                    <img src={membership.photo} alt={membership.name} />
                                    <h3>{membership.name}</h3>
                                    <p className="price">${membership.price}/month</p>
                                    <button className="select-btn">
                                        {selectedMembership?.id === membership.id ? 'Selected' : 'Select'}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </>
                );
        }
    };

    return (
        <div className="memberships-container">
            <div className="memberships-header">
                <h2>Premium Detailing Memberships</h2>
                <div className="summary-notes">
                    {membershipSummary.map(item => (
                        <p key={item.id} className="summary-note">{item.note}</p>
                    ))}
                </div>
            </div>
            {renderStep()}
        </div>
    );
};

export default Memberships;